<template>
  <div class="homeWrap mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">软件产品</div>
      <div class="text2">让数据管理更有序，让安全管控更可靠</div>
    </div>
    <div class="softwareBox" @click="navTo('/product/software')">
      <div class="softRow flex align-center justify-between" v-for="(row, rowIndex) in softTimeLine" :key="rowIndex">
        <div v-if="row.beforeTag" class="softTimeTag flex align-center justify-center">
          {{ row.beforeTag }}
        </div>
        <div class="softInfo flex maria" :class="!softInfo.tags && 'align-center'" v-for="(softInfo, index) in row.list"
          :key="index">
          <OssImg class="softIcon" :src="softInfo.icon" />
          <div class="softText">
            <div :style="{ marginBottom: !softInfo.tags ? '1rem' : '0' }">
              {{ softInfo.title }}
            </div>
            <div>{{ softInfo.subTitle }}</div>
            <div class="flex" v-if="softInfo.tags">
              <div class="softTag" v-for="(tag, tagIndex) in softInfo.tags" :key="tagIndex">
                <el-icon size="13" color="#52C41A" style="margin-right: 4px">
                  <CircleCheck />
                </el-icon>
                {{ tag }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="row.afterTag" class="softTimeTag flex align-center justify-center">
          {{ row.afterTag }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { navTo } from '@/utils/util'
//软件产品
const softTimeLine = ref([
  {
    beforeTag: "实验前",
    list: [
      {
        icon: "images/homeIcon1.png",
        title: "实验室预约系统",
        subTitle: "实验室资源 “智慧调度员”",
        tags: ["多端考试", "实时监控", "全程追溯", "高效统筹"],
      },
      {
        icon: "images/homeIcon2.png",
        title: "安全准入考试系统",
        subTitle: "精准对接准入标准，智能优化考核流程",
        tags: ["智能预约", "流转记录", "准入证书", "数据分析"],
      },
    ],
  },
  {
    beforeTag: "实验中",
    list: [
      {
        icon: "images/homeIcon3.png",
        title: "危化品过程追踪",
        subTitle: "让每一步流转都 “有迹可循”",
        tags: ["使用申请", "流转记录", "使用计量", "电子台账"],
      },
      {
        icon: "images/homeIcon4.png",
        title: "配伍禁忌",
        subTitle: "提示风险，提供安全替代方案",
      },
      {
        icon: "images/homeIcon5.png",
        title: "分类分级",
        subTitle: "以分类划清边界，用分级精准施策",
      },
    ],
  },
  {
    beforeTag: "实验后",
    list: [
      {
        icon: "images/homeIcon6.png",
        title: "危废处理",
        subTitle: "规范操作，守住环保底线",
      },
      {
        icon: "images/homeIcon7.png",
        title: "数据上报",
        subTitle: "规范数据标准，多资源数据互通",
      },
      {
        icon: "images/homeIcon8.png",
        title: "实验室安全检查",
        subTitle: "检查筑防线，隐患排查不松懈",
        tags: ["智能巡检", "隐患溯源", "标准联动", "数据看板"],
      },
    ],
  },
]);
</script>

<style lang="scss" scoped>
.softwareBox {
  width: 100%;

  .softRow {
    width: 100%;
    gap: 1.5rem;
    margin-bottom: 1.5rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    .softTimeTag {
      width: 2.1875rem;
      height: 8.25rem;
      border-radius: 0 1rem 1rem 0;
      writing-mode: vertical-lr;
      letter-spacing: 5px;
      color: #fff;
      font-size: 0.875rem;
    }

    &:first-child .softTimeTag {
      background: #32A89E;
    }

    &:nth-child(2) .softTimeTag {
      background: #faad14;
      // border-radius: 1rem 0 0 1rem;
    }

    &:nth-child(3) .softTimeTag {
      background: #49acfd;
    }

    .softInfo {
      flex-grow: 1;
      height: 8.25rem;
      padding: 16px;
      box-sizing: border-box;
      background: #fff;
      border-radius: 1rem;

      .softIcon {
        width: 4rem;
        height: 4rem;
        margin-right: 1rem;
      }

      .softText {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        >div:first-child {
          font-size: 1rem;
          font-weight: 500;
          line-height: 1.375rem;
          color: #424242;
          margin-top: 0.1875rem;
          white-space: nowrap;
        }

        >div:nth-child(2) {
          font-size: 0.875rem;
          font-weight: 500;
          line-height: 1.375rem;
          color: #888888;
          white-space: nowrap;
        }

        .softTag {
          font-size: 0.875rem;
          font-weight: 500;
          line-height: 1.375rem;
          color: #424242;
          display: flex;
          align-items: center;
          margin-right: 1rem;
          white-space: nowrap;
        }

        .softTag:last-of-type{
          margin-right: 0;
        }
      }
    }
  }
}

// @media(max-width:768px) {
//   .softRow {
//     width: 100vw;
//     overflow: scroll;

//     /* 隐藏滚动条 */
//     .scrollbar {
//       width: 0 !important;
//     }

//     scrollbar-width: none !important;
//   }
// }
</style>
